import { createContext } from "react";
import { User } from "../utils/helpers/types";

const UserContext = createContext<{
  user: User | null;
  setUser: (user: User | null) => void;
}>({ user: null, setUser: () => {} });

export default UserContext;
